/* ===========================================================================
   Barra fixa de compra — duas correcoes que exigem JS.

   1. O <select> de variante nasce dentro de .sticky__left, junto da foto e do
      nome. Visualmente ele pertence ao lado do botao: e a ultima escolha
      antes de comprar. Movemos no DOM porque left e o bloco do botao sao
      containers flex diferentes — order/margin nao atravessam os dois.

   2. O tema atualiza o preco com querySelector, que pega SO o primeiro
      .price-regular da pagina — o do bloco de compra. O preco da barra
      ficava congelado no valor da variante inicial. Aqui espelhamos o bloco
      principal na barra a cada mudanca, entao os dois nunca divergem.
   =========================================================================== */
(function () {
  function init() {
    var barra = document.querySelector('sticky-add-cart');
    if (!barra) return;

    var seletor = barra.querySelector('.sticky__variant');
    var acoes = barra.querySelector('.sticky__item-info');
    if (seletor && acoes && seletor.nextElementSibling !== acoes) {
      acoes.parentNode.insertBefore(seletor, acoes);
    }

    var origem = document.querySelector('.product-detail__price');
    var destino = barra.querySelector('.sticky__price-mobile');
    if (!origem || !destino || origem.contains(destino)) return;

    function espelhar() {
      if (destino.innerHTML !== origem.innerHTML) {
        destino.innerHTML = origem.innerHTML;
      }
    }
    espelhar();

    if (typeof MutationObserver === 'undefined') return;
    if (barra.__psPrecoObs) barra.__psPrecoObs.disconnect();
    barra.__psPrecoObs = new MutationObserver(espelhar);
    barra.__psPrecoObs.observe(origem, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* editor de temas: a secao e trocada por HTML novo */
  document.addEventListener('shopify:section:load', init);
})();
